{
  "defaultLocale": "en",
  "storageKey": "algorithmic-network-language-v1",
  "languages": [
    { "code": "en", "nativeLabel": "English", "shortLabel": "EN", "direction": "ltr" },
    { "code": "es", "nativeLabel": "Español", "shortLabel": "ES", "direction": "ltr" },
    { "code": "pt-BR", "nativeLabel": "Português (Brasil)", "shortLabel": "PT", "direction": "ltr" },
    { "code": "fr", "nativeLabel": "Français", "shortLabel": "FR", "direction": "ltr" },
    { "code": "ar", "nativeLabel": "العربية", "shortLabel": "AR", "direction": "rtl" },
    { "code": "de", "nativeLabel": "Deutsch", "shortLabel": "DE", "direction": "ltr" }
  ]
}
